import { UserCircle2 } from "lucide-react";
import { useLocation } from "react-router-dom";
import { getAuthUser } from "../../api/authApi";

export default function Navbar() {

   const user = getAuthUser();

  const location = useLocation();

  const getPageTitle = () => {
    switch (true) {
      case location.pathname.startsWith("/dashboard"):
        return "Dashboard";

      case location.pathname.startsWith("/product"):
        return "Product";

      case location.pathname.startsWith("/category"):
        return "Category";

      case location.pathname.startsWith("/subcategory"):
        return "Sub Category";

      case location.pathname.startsWith("/project"):
        return "Project";

      case location.pathname.startsWith("/home-page"):
        return "Home Page";

      case location.pathname.startsWith("/quotation"):
        return "Quotation";

      case location.pathname.startsWith("/dos"):
        return "DOS";

      case location.pathname.startsWith("/invoice"):
        return "Invoice";

      case location.pathname.startsWith("/User"):
        return "Users";

      case location.pathname.startsWith("/Sales"):
        return "Sales";

      default:
        return "Dashboard";
    }
  };
  return (
    <header className="bg-white rounded-[24px] h-[82px] px-8 flex justify-between items-center shadow-sm w-full">
      <h1 className="text-4xl font-black tracking-wide"> {getPageTitle()}</h1>

      <div className="flex items-center gap-4">
        <div className="text-right">
          <p className="text-xs text-gray-500"> {user?.name ?? "-"}</p>

          <p className="font-semibold text-sm"> {user?.role ?? "-"}</p>
        </div>

        <div className="bg-gray-200 rounded-full p-2">
          <UserCircle2 size={34} />
        </div>
      </div>
    </header>
  );
}
